import * as React from 'react';
import CircleExclamationPointOutlined from './circle-exclamation-point-outlined';
import CircleExclamationPointFilled from './circle-exclamation-point-filled';
import type { IconCombinedProps } from './types';
const CircleExclamationPointCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CircleExclamationPointFilled ref={ref} {...rest} />;
  }
  return <CircleExclamationPointOutlined ref={ref} {...rest} />;
});
export default CircleExclamationPointCombined;